const STORAGE_KEY = 'search_history';
const MAX_HISTORY_ITEMS = 5;

/**
 * Сохранить поисковый запрос в историю
 * @param {string} query - Поисковый запрос
 */
export const saveSearchQuery = (query) => {
  if (!query || query.trim().length < 2) {
    return;
  }

  try {
    const history = getSearchHistory();
    const trimmedQuery = query.trim();

    // Удаляем дубликаты
    const filtered = history.filter(item => item.toLowerCase() !== trimmedQuery.toLowerCase());

    // Добавляем в начало
    const newHistory = [trimmedQuery, ...filtered].slice(0, MAX_HISTORY_ITEMS);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(newHistory));
  } catch (error) {
    // Error saving search query
  }
};

/**
 * Получить историю поиска
 * @returns {Array<string>} - Массив последних поисковых запросов
 */
export const getSearchHistory = () => {
  try {
    const history = localStorage.getItem(STORAGE_KEY);
    return history ? JSON.parse(history) : [];
  } catch (error) {
    return [];
  }
};

/**
 * Очистить историю поиска
 */
export const clearSearchHistory = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // Error clearing search history
  }
};
